import LoadsListDialog from "./LoadsListDialog";

export default LoadsListDialog;